/* DEV-2026-0220 — Live-Karte im Hintergrund des Mockup-Teasers.
 *
 * Die Karte ist reine Dekoration: nicht bedienbar, kein Zoom, kein Scroll-Fang.
 * Sie darf unter keinen Umständen die Seite blockieren — schlägt das Laden fehl,
 * bleibt der dunkle Rahmen stehen und Überschrift, Text und Button sind
 * unverändert lesbar. Deshalb kein throw, nur eine Konsolenmeldung.
 *
 * Standardmäßig lädt die Karte erst, wenn die Fläche in Sichtweite kommt. Für
 * die Ladezeit-Messung kann die Section auf "sofort laden" gestellt werden —
 * das ist der ungünstigste Fall und zeigt die volle Auswirkung.
 *
 * MEHRERE INSTANZEN AUF EINER SEITE sind ausdrücklich vorgesehen: für den
 * Ladezeit-Vergleich soll die Section mehrfach mit verschiedenen Einstellungen
 * platziert werden können. Der erste Wurf nutzte `querySelector` und traf damit
 * immer nur die erste Fläche — bei fünf Instanzen blieben vier leer. Zusätzlich
 * bindet jede Instanz dieselbe Skriptdatei ein, das Skript läuft also mehrfach:
 * ohne Merker rief der zweite Lauf `L.map()` auf einem bereits aufgebauten
 * Container auf, was Leaflet mit "Map container is already initialized"
 * abbricht — die erste Karte wurde dadurch fälschlich als fehlerhaft markiert.
 * Deshalb: alle Flächen einsammeln und jede genau einmal aufbauen.
 */
(function () {
  'use strict';

  function initialisiere(wurzel) {
    var ziel = wurzel.querySelector('[data-htm-karte]');
    if (!ziel) return;

    // Schon aufgebaut (oder von einem parallelen Skriptlauf übernommen)?
    if (ziel.getAttribute('data-htm-init') === 'true') return;
    ziel.setAttribute('data-htm-init', 'true');

    var anbieter = wurzel.dataset.anbieter || 'osm';
    var stil = wurzel.dataset.kartenStil || 'dunkel';
    var zoom = parseInt(wurzel.dataset.zoom || '6', 10);
    var sofort = wurzel.dataset.sofort === 'true';
    // 'auto' richtet den Ausschnitt an den Händlern aus, 'fest' nutzt den
    // Zoom-Regler der Section. Ohne diese Unterscheidung überschrieb
    // fitBounds den Regler stillschweigend — eine Einstellung, die nichts
    // tut, ist irritierender als keine.
    var ausschnitt = wurzel.dataset.ausschnitt || 'auto';
    var mitPins = wurzel.dataset.pins === 'true';
    var gestartet = false;

    // Kartenstil als Attribut, damit das CSS den Dunkelfilter setzen kann.
    ziel.setAttribute('data-stil', stil);

    /** Koordinaten aus dem von Liquid gerenderten JSON. Fehlerhaftes JSON darf
     *  die Karte nicht verhindern — dann eben ohne Pins. */
    function punkteLesen() {
      if (!mitPins) return [];
      var el = wurzel.querySelector('[data-htm-punkte]');
      if (!el) return [];
      try {
        var liste = JSON.parse(el.textContent || '[]');
        return Array.isArray(liste)
          ? liste.filter(function (p) {
              return Array.isArray(p) && isFinite(p[0]) && isFinite(p[1]);
            })
          : [];
      } catch (e) {
        return [];
      }
    }

    function skriptLaden(url) {
      return new Promise(function (fertig, fehler) {
        var s = document.createElement('script');
        s.src = url;
        s.async = true;
        s.onload = fertig;
        s.onerror = function () { fehler(new Error('Skript nicht ladbar: ' + url)); };
        document.head.appendChild(s);
      });
    }

    function stilLaden(url) {
      return new Promise(function (fertig) {
        var l = document.createElement('link');
        l.rel = 'stylesheet';
        l.href = url;
        l.onload = fertig;
        l.onerror = fertig;   // Ohne Leaflet-CSS sitzen die Kacheln falsch, ist aber kein Abbruchgrund
        document.head.appendChild(l);
      });
    }

    function platzhalterWeg() {
      var p = ziel.querySelector('.htm__karte-platz');
      if (p) p.remove();
    }

    /** Leaflet + OpenStreetMap — ohne Schlüssel und ohne Abrechnung.
     *  Der dunkle Look entsteht per CSS-Filter auf der Kachel-Ebene. */
    function osmAufbauen() {
      var basis = 'https://unpkg.com/leaflet@1.9.4/dist/';
      return stilLaden(basis + 'leaflet.css')
        .then(function () { return skriptLaden(basis + 'leaflet.js'); })
        .then(function () {
          platzhalterWeg();
          var karte = L.map(ziel, {
            zoomControl: false,
            attributionControl: true,
            scrollWheelZoom: false,
            dragging: false,
            doubleClickZoom: false,
            boxZoom: false,
            keyboard: false,
            touchZoom: false,
            tap: false,
          }).setView([51.2, 10.2], zoom);

          L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 18,
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
          }).addTo(karte);

          var punkte = punkteLesen();
          if (punkte.length) {
            // Schlichte Kreise statt Bild-Marker: keine zusätzlichen Requests,
            // und sie liegen außerhalb der Kachel-Ebene, werden vom Dunkelfilter
            // also nicht mit invertiert.
            punkte.forEach(function (p) {
              L.circleMarker([p[0], p[1]], {
                radius: 4,
                color: '#fff',
                weight: 1.5,
                fillColor: '#e8b923',
                fillOpacity: 0.95,
                interactive: false,
              }).addTo(karte);
            });

            /* Ausschnitt an den Händlern ausrichten. Mit festem Zoom 6 füllte die
             * Karte halb Europa, während im Mockup Deutschland die Fläche
             * einnimmt. fitBounds passt sich zudem von selbst an, wenn später
             * Standorte in weiteren Ländern hinzukommen.
             * `animate: false`, weil beim Erstaufbau keine Bewegung sichtbar
             * sein soll. */
            if (ausschnitt === 'auto') {
              try {
                karte.fitBounds(punkte, { padding: [24, 24], animate: false });
              } catch (e) {
                /* Bei unbrauchbaren Koordinaten bleibt die Startansicht stehen. */
              }
            }
          }
        });
    }

    /** Google Maps — nur mit hinterlegtem Schlüssel, dunkler Stil per styles. */
    function googleAufbauen() {
      var key = wurzel.dataset.googleKey;
      if (!key) return Promise.reject(new Error('Kein Google-Maps-Schlüssel hinterlegt'));
      return skriptLaden('https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(key)).then(function () {
        platzhalterWeg();
        var dunkel = [
          { elementType: 'geometry', stylers: [{ color: '#242f3e' }] },
          { elementType: 'labels.text.stroke', stylers: [{ color: '#242f3e' }] },
          { elementType: 'labels.text.fill', stylers: [{ color: '#746855' }] },
          { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#17263c' }] },
          { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#38414e' }] },
          { featureType: 'poi', stylers: [{ visibility: 'off' }] },
          { featureType: 'transit', stylers: [{ visibility: 'off' }] },
        ];
        var karte = new google.maps.Map(ziel, {
          center: { lat: 51.2, lng: 10.2 },
          zoom: zoom,
          disableDefaultUI: true,
          gestureHandling: 'none',
          keyboardShortcuts: false,
          clickableIcons: false,
          styles: stil === 'dunkel' ? dunkel : [],
        });
        var punkte = punkteLesen();
        var grenzen = new google.maps.LatLngBounds();
        punkte.forEach(function (p) {
          var pos = { lat: p[0], lng: p[1] };
          new google.maps.Marker({
            position: pos,
            map: karte,
            clickable: false,
            icon: {
              path: google.maps.SymbolPath.CIRCLE,
              scale: 4,
              fillColor: '#e8b923',
              fillOpacity: 0.95,
              strokeColor: '#fff',
              strokeWeight: 1.5,
            },
          });
          grenzen.extend(pos);
        });
        // Gleicher Ausschnitt wie bei OpenStreetMap, damit ein Wechsel des
        // Anbieters das Bild nicht verändert.
        if (punkte.length && ausschnitt === 'auto') karte.fitBounds(grenzen, 24);
      });
    }

    function starten() {
      if (gestartet) return;
      gestartet = true;
      var aufbau = anbieter === 'google' ? googleAufbauen() : osmAufbauen();
      aufbau.catch(function (err) {
        // Der Teaser bleibt vollständig lesbar — deshalb nur ein Hinweis.
        if (window.console && console.warn) {
          console.warn('[haendler-teaser] Karte nicht verfügbar:', err.message);
        }
        ziel.setAttribute('data-fehler', 'true');
      });
    }

      if (sofort || !('IntersectionObserver' in window)) {
        starten();
      } else {
        var beobachter = new IntersectionObserver(function (eintraege) {
          if (eintraege.some(function (i) { return i.isIntersecting; })) {
            beobachter.disconnect();
            starten();
          }
        }, { rootMargin: '150px' });
        beobachter.observe(ziel);
      }
  }

  // Jede Fläche der Seite aufbauen, nicht nur die erste.
  var flaechen = document.querySelectorAll('[data-htm][data-hintergrund="karte"]');
  for (var i = 0; i < flaechen.length; i++) initialisiere(flaechen[i]);
})();
